<template>
  <div class="main row">
    <div class="col-md-12">
      <KTCodePreview v-bind:title="'Danh sách khoản mục phí'">
        <template v-slot:toolbar>
          <b-button
            v-if="checkPermission('COST_ITEM_INSERT')"
            variant="primary"
            size="sm"
            @click="addNew"
          >
            <i class="fas fa-plus"></i> Thêm mới
          </b-button>
        </template>

        <template v-slot:preview>
          <b-row class="mb-5">
            <b-col cols="3">
              <b-form-select
                v-model="filterCompanyId"
                :options="companyOptions"
                size="sm"
              />
            </b-col>
            <b-col cols="3">
              <b-form-select
                v-model="filterCostGroupId"
                :options="costGroupOptions"
                size="sm"
              />
            </b-col>
            <b-col cols="3">
              <b-form-select
                v-model="filterStatus"
                :options="statusOptions"
                size="sm"
              />
            </b-col>
          </b-row>
          <b-row class="mb-5">
            <b-col cols="4">
              <b-form-input
                v-model="filterNameSearch"
                size="sm"
                placeholder="Tìm theo tên khoản mục"
                @keyup.enter="onFilter"
              />
            </b-col>
            <b-col cols="2">
              <b-button variant="primary" size="sm" @click="onFilter">
                <i class="fas fa-search"></i> Lọc
              </b-button>
            </b-col>
          </b-row>

          <b-table
            :items="items"
            :fields="fields"
            bordered
            hover
            :busy="onLoading"
          >
            <template #cell(index)="data">
              {{ (page - 1) * 10 + data.index + 1 }}
            </template>
            <template #cell(costGroupName)="data">
              {{ data.item.costGroupName || '' }}
            </template>
            <template #cell(status)="data">
              <b-badge :variant="data.value === 1 ? 'success' : 'danger'">
                {{ data.value === 1 ? 'Hoạt động' : 'Ngừng' }}
              </b-badge>
            </template>
            <template v-slot:cell(actions)="row">
              <div class="d-flex justify-content-center">
                <b-dropdown
                  size="sm"
                  id="dropdown-left"
                  no-caret
                  right
                >
                  <template #button-content>
                    <i class="flaticon2-settings"></i>
                  </template>
                  <b-dropdown-item @click="editItem(row.item)">
                    <span style="color: #3f4254; font-size: 10px">
                      <i class="flaticon2-pen icon-size-sm"></i>
                      &nbsp; Sửa
                    </span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="checkPermission('COST_ITEM_DELETE')"
                    @click="deleteItem(row.item)"
                  >
                    <span style="color: #3f4254; font-size: 10px">
                      <i
                        class="flaticon2-rubbish-bin-delete-button icon-size-sm"
                      ></i>
                      &nbsp; Xóa
                    </span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </template>
          </b-table>

          <b-row class="mt-3 align-items-center">
            <b-col cols="12" md="4">
              Tổng số: <strong>{{ totalRow }}</strong>
            </b-col>
            <b-col cols="12" md="8" class="d-flex justify-content-end">
              <BPaginationNavCustom
                :currentPage="page"
                :numberOfPages="numberOfPage"
                :totalPage="numberOfPage"
                :linkParams="paginationLinkParams"
                @page-change="fetchData"
              />
            </b-col>
          </b-row>
        </template>
      </KTCodePreview>
    </div>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ApiService from '@/core/services/api.service';
import Swal from 'sweetalert2';
import { checkPermission } from '@/utils/saveDataToLocal';
import { makeToastSuccess, makeToastFaile } from '@/utils/common';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';

export default {
  components: { KTCodePreview, BPaginationNavCustom },
  data() {
    return {
      items: [],
      onLoading: false,
      page: 1,
      numberOfPage: 1,
      totalRow: 0,
      filterCompanyId: null,
      filterCostGroupId: null,
      filterStatus: null,
      filterNameSearch: '',
      companyOptions: [{ value: null, text: '-- Doanh nghiệp --' }],
      costGroupOptions: [{ value: null, text: '-- Nhóm phí --' }],
      statusOptions: [
        { value: null, text: '-- Trạng thái --' },
        { value: 1, text: 'Hoạt động' },
        { value: 0, text: 'Ngừng' },
      ],
      fields: [
        { key: 'index', label: 'STT', thStyle: { textAlign: 'center', width: '5%' }, class: 'text-center' },
        { key: 'name', label: 'Tên khoản mục', thStyle: { textAlign: 'center' } },
        { key: 'costGroupName', label: 'Nhóm phí', thStyle: { textAlign: 'center', width: '18%' } },
        { key: 'status', label: 'Trạng thái', thStyle: { textAlign: 'center', width: '10%' }, class: 'text-center' },
        { key: 'actions', label: '', thStyle: { width: '5%' }, class: 'text-center' },
      ],
      linkGen: (pageNum) => (pageNum === 1 ? '?' : `?page=${pageNum}`),
    };
  },
  computed: {
    paginationLinkParams() {
      return {
        companyId: this.filterCompanyId || '',
        costGroupId: this.filterCostGroupId || '',
        status: this.filterStatus !== null ? this.filterStatus : '',
        nameSearch: this.filterNameSearch || '',
      };
    },
  },
  created() {
    this.fetchCompanies();
    this.fetchCostGroups();
    this.fetchData();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Kế toán', route: '#' },
      { title: 'Khoản mục phí' },
    ]);
  },
  methods: {
    checkPermission,
    makeToastSuccess,
    makeToastFaile,
    fetchCompanies() {
      ApiService.get('/company').then(({ data }) => {
        const rows = data.data || [];
        this.companyOptions = [
          { value: null, text: '-- Doanh nghiệp --' },
          ...rows.map((c) => ({ value: c.id, text: c.name })),
        ];
      });
    },
    fetchCostGroups() {
      ApiService.query('v2/cost-groups', { params: { limit: 200 } }).then(({ data }) => {
        if (data.status === 200 && data.data.dataset) {
          const groups = data.data.dataset.map((g) => ({ value: g.id, text: g.name }));
          this.costGroupOptions = [{ value: null, text: '-- Nhóm phí --' }, ...groups];
        }
      });
    },
    onFilter() {
      this.$router.push({ name: 'list-cost-items' }).catch(() => {});
      this.fetchData();
    },
    fetchData() {
      this.onLoading = true;
      this.page = this.$route.query.page || 1;
      const params = {
        page: this.page,
        limit: 10,
        companyId: this.filterCompanyId || '',
        costGroupId: this.filterCostGroupId || '',
        status: this.filterStatus !== null ? this.filterStatus : '',
        nameSearch: this.filterNameSearch || '',
      };
      ApiService.query('v2/cost-items', { params }).then(({ data }) => {
        if (data.status === 200) {
          this.items = data.data.dataset;
          this.numberOfPage = data.data.totalPage;
          this.totalRow = data.data.totalRow || 0;
        } else {
          this.makeToastFaile(data.message);
        }
        this.onLoading = false;
      });
    },
    addNew() {
      this.$router.push({ name: 'add-cost-item' });
    },
    editItem(item) {
      this.$router.push({ name: 'edit-cost-item', query: { id: item.id } });
    },
    deleteItem(item) {
      Swal.fire({
        title: 'Xác nhận xóa?',
        text: `Bạn có chắc muốn xóa khoản mục "${item.name}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Hủy',
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.delete(`v2/cost-items/${item.id}`).then(({ data }) => {
            if (data.status === 200) {
              this.makeToastSuccess(data.message);
              this.fetchData();
            } else {
              this.makeToastFaile(data.message);
            }
          });
        }
      });
    },
  },
};
</script>
